export default __webpack_public_path__ + "static/media/user-status-icon-green.d6051477.svg";